module.exports = __webpack_public_path__ + "img/Multi-Tab-Folder.36e25b43.png";